import { render } from "./TrackerCreate.vue?vue&type=template&id=046d70d9"
import script from "./TrackerCreate.vue?vue&type=script&lang=js"
export * from "./TrackerCreate.vue?vue&type=script&lang=js"
script.render = render

export default script